import React from "react";
import RegFormCustomer from "./RegFormCustomer";
import HeaderCustomer from "./HeaderCustomer";
import Layout from "../Layout";

const RegCustomer = () => (
    <Layout>
    <HeaderCustomer />
    <section className="layout-container">
      <div className="container">
        <div className="descript-container container-2">
          <div className="form-title g-clr">Registration</div>
          Fill out the form below to set up a new customer account according to their requirements.
        </div>
        <RegFormCustomer />
      </div>
        </section>
    </Layout>

);


export default RegCustomer;
